import React from 'react';
import { useParams } from 'react-router-dom';

import { Modal } from 'components/Modal';
import { Instructions } from 'components/modals/Instructions';
import { Settings } from 'components/modals/Settings';
import { Info } from 'components/modals/Info';
import { GameSelection } from 'components/modals/GameSelection';
import { GiveUp } from 'components/modals/GiveUp';
import { Feedback } from 'components/modals/Feedback';
import { FAQ } from 'components/modals/FAQ';
import { Current } from 'components/modals/Current';
import { useModal } from 'common/hooks';

function ModalSelector({
  lastGameId,
  onSelectGame,
  gameData,
  handleGiveUp,
  tipSetting,
  setTipSetting,
  theme,
  setTheme,
  order,
  setOrder,
  openGameId,
  current,
}) {
  const modal = useModal();
  const { language } = useParams();

  const onClose = () => {
    modal.close();
  };

  if (!modal.id) {
    return null;
  }

  let modalContent;

  if (modal.id === 'instructions') {
    modalContent = <Instructions />;
  }

  if (modal.id === 'previous') {
    modalContent = (
      <GameSelection
        lastGameId={lastGameId}
        onSelectGame={onSelectGame}
        gameData={gameData[language]}
      />
    );
  }

  if (modal.id === 'current') {
    modalContent = (
      <Current
        gameId={openGameId}
        loading={current[openGameId].loading}
        data={current[openGameId].data}
      />
    );
  }

  if (modal.id === 'info') {
    modalContent = <Info />;
  }

  if (modal.id === 'giveUp') {
    modalContent = (
      <GiveUp onConfirm={handleGiveUp} onCancel={() => modal.close()} />
    );
  }

  if (modal.id === 'settings') {
    modalContent = (
      <Settings
        tipSetting={tipSetting}
        onTipSettingChange={setTipSetting}
        theme={theme}
        onThemeChange={setTheme}
        order={order}
        onOrderChange={setOrder}
      />
    );
  }

  if (modal.id === 'feedback') {
    modalContent = <Feedback />;
  }

  if (modal.id === 'faq') {
    modalContent = <FAQ />;
  }

  return <Modal onClose={onClose}>{modalContent}</Modal>;
}

export default ModalSelector;
